var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("h2", { staticClass: "border-none" }, [
      _vm._v(
        "Which of the interests that you previously selected would you be comfortable talking about?"
      ),
    ]),
    _vm._v(" "),
    _c("div", [
      _c("div", { staticClass: "spacer-b-2 lead-text" }, [
        _vm._v(
          "Specialist topics will increase your chance of being shortlisted for"
        ),
      ]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "spacer-t-5 lead-text" }, [
        _vm._v("Select all the specialist topics which apply"),
      ]),
      _vm._v(" "),
      !_vm.selectedCategories ||
      (_vm.selectedCategories && !_vm.selectedCategories.length)
        ? _c(
            "div",
            {
              staticClass:
                "flex justify-center spacer-y-2 spacer-x-2 margin-y-2 text-center",
              staticStyle: { "background-color": "white" },
            },
            [
              _c(
                "div",
                [
                  _c(
                    "router-link",
                    {
                      attrs: {
                        to: {
                          params: { page: "interests" },
                          query: this.$route.query,
                        },
                      },
                    },
                    [_vm._v("Add interests")]
                  ),
                  _vm._v(" from our list or suggest your own below."),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "w-full flex flex-wrap" },
        _vm._l(_vm.selectedCategories, function (category) {
          return _c(
            "div",
            {
              key: category.id,
              staticClass: "category",
              class: category.type === "specialist" ? "category--selected" : "",
              on: {
                click: function ($event) {
                  return _vm.$emit(
                    "toggled",
                    category.id,
                    category.group,
                    category.name
                  )
                },
              },
            },
            [
              _c("i", {
                staticClass: "fa",
                class: category.type === "specialist" ? "fa-check" : "fa-plus",
              }),
              _vm._v("\n        " + _vm._s(category.name) + "\n      "),
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _vm.customCategories && _vm.customCategories.length
        ? _c("div", { staticClass: "spacer-t-5" }, [_vm._v("Under review")])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "w-full flex flex-wrap" },
        _vm._l(_vm.customCategories, function (category) {
          return _c(
            "div",
            {
              key: category.id,
              staticClass: "category",
              class: category.type === "specialist" ? "category--selected" : "",
              on: {
                click: function ($event) {
                  return _vm.$emit("toggled", category.id)
                },
              },
            },
            [
              _c("i", {
                staticClass: "fa",
                class: category.type === "specialist" ? "fa-check" : "fa-plus",
              }),
              _vm._v("\n        " + _vm._s(category.name) + "\n      "),
            ]
          )
        }),
        0
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      [
        _c("div", { staticClass: "margin-y-2 lead-text" }, [
          _vm._v("Any other specialist topics you would like to talk about?"),
        ]),
        _vm._v(" "),
        _c("search-picker", {
          attrs: {
            "full-width": true,
            "with-icon": true,
            "with-popper": true,
            "get-data": _vm.getInterestCategories,
            current: _vm.selectedCategories,
            placeholder: "Add topic",
          },
          on: {
            selected: (option) => {
              _vm.$emit("selected", option)
            },
          },
          scopedSlots: _vm._u([
            {
              key: "list-item-content",
              fn: function ({ option }) {
                return [
                  option.group
                    ? _c("div", { staticClass: "search-picker__subtext" }, [
                        _c("span", [_vm._v(_vm._s(option.group))]),
                      ])
                    : _vm._e(),
                ]
              },
            },
          ]),
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "flex flex-row flex-wrap gray-500 w-2/3 justify-between" },
      [
        _c("div", { staticClass: "info-item" }, [
          _c(
            "div",
            { staticClass: "w-2/10 flex justify-center align-center" },
            [_c("i", { staticClass: "fa fa-microphone" })]
          ),
          _vm._v(" Guest Speaking"),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "info-item" }, [
          _c(
            "div",
            { staticClass: "w-2/10 flex justify-center align-center" },
            [_c("i", { staticClass: "fa fa-laptop" })]
          ),
          _vm._v(" Q&A"),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "info-item" }, [
          _c(
            "div",
            { staticClass: "w-2/10 flex justify-center align-center" },
            [_c("i", { staticClass: "fa fa-bar-chart" })]
          ),
          _vm._v(" Keynotes"),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "info-item" }, [
          _c(
            "div",
            { staticClass: "w-2/10 flex justify-center align-center" },
            [_c("i", { staticClass: "fa fa-comments" })]
          ),
          _vm._v(" Social Media Campaigns"),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }